import { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress, Box, Avatar, Typography } from '@mui/material';
import { GetCustomersList } from 'api/customers';

const initials = (name) => {
  const p = (name || '?').trim().split(/\s+/);
  return (p.length >= 2 ? p[0][0] + p[1][0] : (name || '?').slice(0, 2)).toUpperCase();
};

// Type-to-search customer picker, modeled on the SelfPickup customer field but
// resolving to an exact Customer selection (filters by _id) instead of free text —
// shared by the Financial Dashboard's Shipping + Top-up approval filter bars.
const CustomerSearchAutocomplete = ({ value, onChange, label, size = 'small', sx }) => {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!inputValue) {
      setOptions([]);
      return;
    }
    let active = true;
    setLoading(true);
    GetCustomersList(inputValue)
      .then((res) => { if (active) setOptions(res && res.success ? res.data : []); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [inputValue]);

  return (
    <Autocomplete
      size={size}
      sx={sx}
      value={value || null}
      inputValue={inputValue}
      onInputChange={(e, val) => setInputValue(val)}
      onChange={(e, customer) => onChange(customer || null)}
      options={options}
      loading={loading}
      filterOptions={(x) => x}
      isOptionEqualToValue={(opt, val) => opt._id === val._id}
      getOptionLabel={(opt) => (opt?.name ? `${opt.name}${opt.whatsapp ? ` - ${opt.whatsapp}` : ''}` : '')}
      renderOption={(props, opt) => (
        <Box component="li" {...props} key={opt._id}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
            <Avatar sx={{ width: 28, height: 28, fontSize: 11, fontWeight: 700, background: 'linear-gradient(135deg,#7c3aed,#4c1d95)' }}>
              {initials(opt.name)}
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="body2" fontWeight={700} noWrap>{opt.name}</Typography>
              {opt.whatsapp && <Typography variant="caption" color="text.secondary">{opt.whatsapp}</Typography>}
            </Box>
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={16} sx={{ mr: 1 }} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default CustomerSearchAutocomplete;
